import { twMerge } from "tailwind-merge";
import {
  AuthActionsBase,
  type AuthActionsBaseProps,
} from "@core/features/auth";
import { Button } from "@themes/pollinator/ui/Button";
import { GoogleButton } from "@themes/pollinator/ui/GoogleButton";

export type Props = Omit<
  AuthActionsBaseProps,
  "renderSubmitButton" | "renderGoogleButton"
>;

export function AuthButtons({
  className,
  onSubmit,
  onSubmitWithGoogle,
  isSubmitting,
  isLoading,
  isValid,
  submitLabel,
  googleLabel,
  isWithBorder = true,
  isWithPadding = true,
  signupButtonClassName,
  googleButtonClassName,
}: Props) {
  const isLoadingOrSubmitting = isLoading || isSubmitting;

  return (
    <AuthActionsBase
      onSubmit={onSubmit}
      onSubmitWithGoogle={onSubmitWithGoogle}
      isSubmitting={isSubmitting}
      isLoading={isLoading}
      isValid={isValid}
      submitLabel={submitLabel}
      googleLabel={googleLabel}
      signupButtonClassName={signupButtonClassName}
      googleButtonClassName={googleButtonClassName}
      className={twMerge(
        "flex flex-col items-start gap-3 transition-opacity duration-200",
        isWithBorder && "border-t border-brand-800",
        isWithPadding && "px-8 py-4",
        isLoadingOrSubmitting && "opacity-20 bg-brand-50",
        className
      )}
      renderSubmitButton={({
        onClick,
        disabled,
        visuallyDisabled,
        label,
        className,
      }) => (
        <Button
          variant="primary"
          theme="light"
          onClick={onClick}
          disabled={disabled}
          visuallyDisabled={visuallyDisabled}
          className={className}
        >
          {label}
        </Button>
      )}
      renderGoogleButton={({ onClick, label, className }) => (
        <GoogleButton label={label} onClick={onClick} className={className} />
      )}
    />
  );
}

export default AuthButtons;

